
export default {
  state: {
    isReminderOff: false,
    isModalOpened: true
  },
  getters: {},
  mutations: {
    setisReminderOff(state, data) {
      state.isReminderOff = data
    },
    setIsModalOpened(state, data) {
      state.isModalOpened = data
    }
  },
  actions: {
    getModalStatus(context, value) {
      context.commit('setIsModalOpened', value)
    },
    getReminderStatus(context, value) {
      context.commit('setisReminderOff', value)
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/advertisement.js